import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    selectedGroup: "",
    selectedPrepod: ""
  },
  mutations: {
    changeGroup (state, group) {
      state.selectedGroup = group
    },
    changePrepod (state, prepod) {
      state.selectedPrepod = prepod
    }
  }
})

Vue.prototype.$store = store;

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
